import React from 'react';

const HomeSkeletonLoader = () => {
  return (
    <div className="bg-gray-50 min-h-screen animate-pulse">
      {/* Hero Image Skeleton */}
      <div className="relative h-[40vh] bg-gray-200"></div>
      
      {/* Project Info Skeleton */}
      <div className="px-4 -mt-6">
        <div className="shadow-2xl bg-white rounded-xl shadow-sm p-4 mt-8 mb-3">
          <div className="grid grid-cols-3 gap-4">
            {[1, 2, 3].map((item) => (
              <div key={item} className="text-center">
                <div className="h-8 w-12 bg-gray-200 rounded mx-auto mb-1"></div>
                <div className="h-3 w-16 bg-gray-100 rounded mx-auto"></div>
              </div>
            ))}
          </div>
        </div>

        {/* Quotations Skeleton */}
        <div className="mb-8">
          <div className="h-6 w-48 bg-gray-200 rounded mb-4"></div>
          <div className="space-y-3">
            {[1, 2].map((item) => (
              <div key={item} className="bg-white p-4 rounded-xl border border-gray-100">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-xl bg-gray-200"></div>
                    <div>
                      <div className="h-4 w-32 bg-gray-200 rounded mb-1"></div>
                      <div className="h-3 w-20 bg-gray-100 rounded"></div>
                    </div>
                  </div>
                  <div className="h-5 w-20 bg-gray-200 rounded"></div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Standard Quotations Skeleton */}
        <div className="relative">
          <div className="sticky top-0 z-20 bg-gray-50 pt-4 pb-2">
            <div className="h-6 w-48 bg-gray-200 rounded mb-4"></div>
            
            <div className="flex gap-4 overflow-x-auto no-scrollbar">
              {[1, 2, 3].map((item) => (
                <div key={item} className="flex-shrink-0 h-12 w-28 bg-gray-200 rounded-xl"></div>
              ))}
            </div>
          </div>

          <div className="mt-5 bg-gradient-to-b from-gray-100 rounded-3xl p-4">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {[1, 2, 3].map((item) => (
                <div key={item} className="bg-white rounded-2xl p-6 border border-gray-100">
                  <div className="h-5 w-20 bg-gray-200 rounded-full mb-4"></div>
                  <div className="flex justify-between items-center mb-4">
                    <div className="h-6 w-32 bg-gray-200 rounded"></div>
                    <div className="h-8 w-24 bg-gray-200 rounded-xl"></div>
                  </div>
                  <div className="space-y-3">
                    {[1, 2, 3].map((subItem) => (
                      <div key={subItem} className="bg-gray-100 rounded-lg p-3">
                        <div className="flex items-center gap-2">
                          <div className="w-5 h-5 rounded-md bg-gray-200"></div>
                          <div>
                            <div className="h-4 w-24 bg-gray-200 rounded mb-1"></div>
                            <div className="h-3 w-32 bg-gray-200 rounded"></div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="h-10 w-full bg-gray-200 rounded-xl mt-4"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeSkeletonLoader;
